// Port of api/fuel/app/classes/insights/hindex/indexes.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import HindexType from 'offline/model/hindex/type'
import HindexTrack from 'offline/model/hindex/track'

export default Segment.extend({
    name: 'indexes',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: [],
    detail: [],
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner) {

        // Get hindex IDs the user is tracking
        var trackingIndex = Object.keys(HindexTrack.indexed('hindex_id', {
            where: {
                user_id: owner.get_id()
            }
        })).sort(function(a, b) { return parseInt(a, 10) - parseInt(b, 10) })

        // Get all public indexes, official indexes, and user's own indexes
        var indexRows = Util.query(
            'SELECT hindex_id FROM hindex_type WHERE hindex_public = 1 OR user_id = 0 OR user_id = ' + owner.get_id() +
            ' ORDER BY hindex_official DESC, hindex_users DESC, hindex_name ASC'
        )

        var indexesList = []
        for (var j = 0; j < indexRows.length; j++) {
            var index = HindexType.with_id(indexRows[j].hindex_id)
            if (index) indexesList.push(index.to_json())
        }

        var indexes = {
            tracking: trackingIndex,
            indexes: indexesList
        }

        return {
            indexes: indexes
        }

    }
})
